<template>
	<div>
		<div class="mb-3 image-upload-buttons">
			<label class="btn btn-outline-warning me-2" @click="mobilePicture(true)">
				<i class="bi bi-camera"></i> Take Picture
			</label>
			<label class="btn btn-outline-orange" @click="mobilePicture(false)">
				<i class="bi bi-upload"></i> Upload Image
			</label>
		</div>
		<image-target-editor
			v-if="enableTargeting && editorImage"
			class="mb-3"
			:image-src="editorImage"
			@confirm="handleTargetConfirm"
			@cancel="closeEditor" />
	</div>
</template>

<script setup>
	import { ref, watch, onBeforeUnmount } from "vue"
	// import { Capacitor } from "@capacitor/core"
	import { InAppCamera } from "@/plugins/InAppCamera"
	import {
		Camera,
		// CameraDirection,
		CameraResultType,
		CameraSource,
	} from "@capacitor/camera"
	// import resizeImage from "@/utils/resizeImage"
	import Swal from "sweetalert2"
	import ImageTargetEditor from "./ImageTargetEditor.vue"

	const emits = defineEmits(["update:modelValue", "targetChange", "targetEditorOpen"])
	const props = defineProps({
		saveState: { type: Function },
		enableTargeting: { type: Boolean, default: false },
	})

	// Image data
	const imagePreview = ref(null)
	const editorImage = ref(null)
	// const image = ref(null)

	const disable = ref(false)

	async function mobilePicture(useCamera) {
		if (disable.value) return

		let img = null
		disable.value = true
		try {
			if (useCamera) {
				const camera = await InAppCamera.open({
					quality: 100,
					facing: "environment",
				})

				// if (imagePreview.value) {
				// 	URL.revokeObjectURL(imagePreview.value)
				// }

				imagePreview.value = camera.dataUrl
			} else {
				img = await Camera.getPhoto({
					quality: 100,
					width: 600,
					allowEditing: false,
					resultType: CameraResultType.DataUrl,
					source: CameraSource.Photos,
				})
				// if (imagePreview.value) {
				// 	URL.revokeObjectURL(imagePreview.value)
				// }
				imagePreview.value = img.dataUrl
			}
		} catch (e) {
			// Output error to console and show in SweetAlert
			console.log("Camera/Photos error:", e)
			//if user cancelled ignore
			if (!e.message.toLowerCase().includes("cancelled")) {
				Swal.fire({
					icon: "error",
					title: "Camera Error",
					text:
						e.message ||
						"An error occurred while accessing the camera or photos",
				})
			}
		}
		disable.value = false
		emits("update:modelValue", imagePreview.value)
		emits("targetChange", {
			imageSrc: imagePreview.value,
			targetImageSrc: null,
			targetMode: null,
			targetRegion: null,
		})

		// if (props.saveState) {
		// 	await props.saveState()
		// }
		// let img = null
		// try {
		// 	img = await Camera.getPhoto({
		// 		quality: 100,
		// 		allowEditing: false,
		// 		resultType: CameraResultType.DataUrl,
		// 		width: 600,
		// 		source: useCamera ? CameraSource.Camera : CameraSource.Photos,
		// 		direction: CameraDirection.Rear,
		// 	})
		// 	// 	alert("IN HERE")
		// } catch (e) {
		// 	// Output error to console and show in SweetAlert
		// 	console.log("Camera/Photos error:", e)
		// 	Swal.fire({
		// 		icon: "error",
		// 		title: "Camera Error",
		// 		text:
		// 			e.message || "An error occurred while accessing the camera or photos",
		// 	})
		// }
		// if (img) {
		// 	imagePreview.value = img.dataUrl
		// 	// Convert dataUrl to blob for further usage
		// 	// const res = await fetch(img.dataUrl)
		// 	// const blob = await res.blob()
		// 	// image.value = blob
		// } else {
		// 	// image.value = null
		// 	imagePreview.value = null
		// }
		// emits("update:modelValue", imagePreview.value)
	}

	function handleTargetConfirm(target) {
		imagePreview.value = target?.imageSrc ?? null
		editorImage.value = null
		emits("update:modelValue", imagePreview.value)
		emits("targetChange", target)
	}

	function closeEditor() {
		editorImage.value = null
	}

	function editTarget(src = imagePreview.value) {
		if (!props.enableTargeting || !src) return
		editorImage.value = src
	}

	watch(editorImage, (value) => {
		emits("targetEditorOpen", !!value)
	})

	defineExpose({
		editTarget,
	})

	onBeforeUnmount(() => {
		if (imagePreview.value) {
			// URL.revokeObjectURL(imagePreview.value)
			imagePreview.value = null
		}
		editorImage.value = null
	})
</script>

<style lang="less" scoped>
	@import "../assets/colors.less";

	.btn-outline-orange {
		border-color: @color4;
		color: @color4;
	}

	.image-upload-buttons {
		display: flex;
		justify-content: start;
		gap: 1rem;
		.btn {
			position: relative;
			i {
				margin-right: 8px;
			}
		}
		input[type="file"] {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			opacity: 0;
			cursor: pointer;
		}
	}
</style>
